/**
 * api 공통
 */
import NetworkService from "@/api/net.service";
import dayjs from "dayjs";

const NetApiServer = new NetworkService("")

/**
 *  리포트 api
 * @type {{getSidoList(): Promise<AxiosResponse<any>>}}
 */
export const ApiReport = {

  /**
   * 엑셀 미리보기 데이터 가져오기
   * @returns {Promise<AxiosResponse<any>>}
   */
  getViewDataPreview(params){
    return NetApiServer.post("/api/report/getViewDataPreview", params).then(res => {
      return res
    })
  },

  /**
   * 엑셀 미리보기 데이터 저장
   * @returns {Promise<AxiosResponse<any>>}
   */
  getViewDataPreviewReport: async (params) => {
    return await NetApiServer.postExcel("/api/report/getViewDataPreviewReport"
      , params, "previewReport" + "_" + dayjs(new Date()).format('YYYYMMDDHHmmss'));
  },

  /**
   * KOQUSS-40 Excel 파일 다운로드
   * @returns {Promise<AxiosResponse<any>>}
   */
  getKoquss40Report: async (params) => {
    return await NetApiServer.postExcel("/api/report/koquss40Report"
      , params, "koquss40Report" + "_" + dayjs(new Date()).format('YYYYMMDDHHmmss'));
  },

  /**
   * KOQUSS-33 Excel 파일 다운로드
   * @returns {Promise<AxiosResponse<any>>}
   */
  getKoquss33Report: async (params) => {
    return await NetApiServer.postExcel("/api/report/koquss33Report"
      , params, "koquss33Report" + "_" + dayjs(new Date()).format('YYYYMMDDHHmmss'));
  },

  /**
   * 식이 및 NRS2002 + 환자증상 Excel 파일 다운로드
   * @returns {Promise<AxiosResponse<any>>}
   */
  getNRS2002Report: async (params) => {
    return await NetApiServer.postExcel("/api/report/nrs2002Report"
      , params, "nrs2002Report" + "_" + dayjs(new Date()).format('YYYYMMDDHHmmss'));
  },

  /**
   * EORTC QLQ-STO22 Excel 파일 다운로드
   * @returns {Promise<AxiosResponse<any>>}
   */
  getSTO22Report: async (params) => {
    return await NetApiServer.postExcel("/api/report/sto22Report"
      , params, "sto22Report" + "_" + dayjs(new Date()).format('YYYYMMDDHHmmss'));
  },

  /**
   * C30 Excel 파일 다운로드
   * @returns {Promise<AxiosResponse<any>>}
   */
  getC30Report: async (params) => {
    return await NetApiServer.postExcel("/api/report/c30Report"
      , params, "c30Report" + "_" + dayjs(new Date()).format('YYYYMMDDHHmmss'));
  },

  /**
   * 신체활동설문(paq) 파일 다운로드
   * @returns {Promise<AxiosResponse<any>>}
   */
  getPAQReport: async (params) => {
    return await NetApiServer.postExcel("/api/report/paqReport"
      , params, "paqReport" + "_" + dayjs(new Date()).format('YYYYMMDDHHmmss'));
  },

  /**
   * 자기효능감(Self-Efficacy) 파일 다운로드
   * @returns {Promise<AxiosResponse<any>>}
   */
  getSelfEfficacyReport: async (params) => {
    return await NetApiServer.postExcel("/api/report/selfEfficacyReport"
      , params, "SelfEfficacyReport" + "_" + dayjs(new Date()).format('YYYYMMDDHHmmss'));
  },

  /**
   * 유럽삶의질(EQ-5D-5L) 파일 다운로드
   * @returns {Promise<AxiosResponse<any>>}
   */
  getEQ5D5LReport: async (params) => {
    return await NetApiServer.postExcel("/api/report/EQ5D5LReport"
      , params, "EQ5D5LReport" + "_" + dayjs(new Date()).format('YYYYMMDDHHmmss'));
  },

  /**
   * 위케어만족도(CSAT) 파일 다운로드
   * @returns {Promise<AxiosResponse<any>>}
   */
  getCSATReport: async (params) => {
    return await NetApiServer.postExcel("/api/report/CSATReport"
      , params, "CSATReport" + "_" + dayjs(new Date()).format('YYYYMMDDHHmmss'));
  },
}
